import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LoginPage from "./login/LoginPage";
import Register from "./login/Usuario/Register";
import UpdatePasswordPage from "./login/Usuario/UpdatePasswordPage";
import UpdatePassworSystem from "./login/UpdatePasswordPage";

import UserPanel from "./login/Usuario/UserPanel";
import AdminPanel from "./login/Administrador/AdminPanel";
import EnterprisePanel from "./login/Empresa/EnterprisePanel";
import NewInvoice from "./login/Empresa/NuevaFactura/NewInvoice";

import AdminSection from "./login/Administrador/AdminSection";
import Section from "./login/Administrador/Section";
import AdminProduct from "./login/Administrador/AdminProduct";
import Product from "./login/Administrador/Product";
import AdminProforma from "./login/Administrador/AdminProforma";
import Proforma from "./login/Administrador/Proforma";
import AdminClient from "./login/Administrador/AdminClient";
import Client from "./login/Administrador/Client";
import AdminVariant from "./login/Administrador/AdminVariant";
import Variant from "./login/Administrador/Variant";
import AdminPromotion from "./login/Administrador/AdminPromotion";
import Promotion from "./login/Administrador/Promotion";
import AdminServices from "./login/Administrador/AdminServices";
import Services from "./login/Administrador/Services";
import AdminInvoice from "./login/Administrador/AdminInvoice";
import Invoice from "./login/Administrador/Invoice";
import RegisterPurchase from "./login/Administrador/RegisterPurchase";
import AdminAccounts from "./login/Administrador/AdminAccounts";
import AdminMotion from "./login/Administrador/AdminMotion";
import Motion from "./login/Administrador/Motion";
import MotionDetail from "./login/Administrador/MotionForm/MotionDetail";
import AdminBank from "./login/Administrador/AdminBank";
import Bank from "./login/Administrador/Bank";
import Payment from "./login/Administrador/Payment/Payment";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/registro" element={<Register />} />
        <Route path="/actualizar-clave" element={<UpdatePasswordPage />} />
        <Route path="/system/update-password" element={<UpdatePassworSystem />} />

        <Route path="/user-panel" element={<UserPanel />} />

        <Route path="/admin-panel/*" element={<AdminPanel />} />
        <Route path="/admin-panel/empresa" element={<EnterprisePanel />} />

        <Route path="/admin-panel/secciones" element={<AdminSection />} />
        <Route path="/admin-panel/secciones/nueva" element={<Section />} />

        <Route path="/admin-panel/inventario/productos" element={<AdminProduct />} />
        <Route path="/admin-panel/inventario/productos/nuevo" element={<Product />} />

        <Route path="/admin-panel/proformas" element={<AdminProforma />} />
        <Route path="/admin-panel/proformas/nueva" element={<Proforma />} />
        <Route path="/admin-panel/proformas/editar/:id" element={<Proforma />} />

        <Route path="/admin-panel/servicios" element={<AdminServices />} />
        <Route path="/admin-panel/servicios/nuevo" element={<Services />} />

        <Route path="/admin-panel/clientes" element={<AdminClient />} />
        <Route path="/admin-panel/clientes/nuevo" element={<Client />} />

        <Route path="/admin-panel/inventario/variantes" element={<AdminVariant />} />
        <Route path="/admin-panel/inventario/variantes/nueva" element={<Variant />} />

        <Route path="/admin-panel/inventario/movimientos" element={<AdminMotion />} />
        <Route path="/admin-panel/inventario/movimientos/nuevo" element={<Motion />} />
        <Route path="/admin-panel/inventario/movimientos/:id" element={<MotionDetail />} />

        <Route path="/admin-panel/promociones" element={<AdminPromotion />} />
        <Route path="/admin-panel/promociones/nueva" element={<Promotion />} />

        <Route path="/admin-panel/registro/documento" element={<NewInvoice />} />
        <Route path="/admin-panel/reporte/documento" element={<AdminInvoice />} />
        <Route path="/admin-panel/compras/registro" element={<RegisterPurchase />} />

        <Route path="/admin-panel/factura/:id" element={<Invoice />} />

        <Route path="/admin-panel/admin-cuentas" element={<AdminAccounts />} />

        <Route path="/admin-panel/bancos" element={<AdminBank />} />
        <Route path="/admin-panel/bancos/nuevo" element={<Bank />} />

        <Route path="/admin-panel/pagos/:id" element={<Payment />} />
      </Routes>
    </Router>
  );
};

export default App;
